import React, { useEffect, useMemo, useState } from 'react';
import { getSgsstRiesgos, crearSgsstRiesgo, editarSgsstRiesgo, borrarSgsstRiesgo } from '../services/api';
import SgsstTabs from '../components/SgsstTabs';

const ND = [{ v: 10, l: 'Muy alto (10)' }, { v: 6, l: 'Alto (6)' }, { v: 2, l: 'Medio (2)' }, { v: 0, l: 'Bajo (0)' }];
const NE = [{ v: 4, l: 'Continua (4)' }, { v: 3, l: 'Frecuente (3)' }, { v: 2, l: 'Ocasional (2)' }, { v: 1, l: 'Esporádica (1)' }];
const NC = [{ v: 100, l: 'Mortal (100)' }, { v: 60, l: 'Muy grave (60)' }, { v: 25, l: 'Grave (25)' }, { v: 10, l: 'Leve (10)' }];
const CLASIF = [
  ['biologico', 'Biológico'], ['fisico', 'Físico'], ['quimico', 'Químico'], ['psicosocial', 'Psicosocial'],
  ['biomecanico', 'Biomecánico'], ['condiciones_seguridad', 'Condiciones de seguridad'], ['fenomenos_naturales', 'Fenómenos naturales'],
];
const NIVEL_COLOR = { I: '#dc2626', II: '#f97316', III: '#eab308', IV: '#10b981' };
const VACIO = { proceso: '', zona_area: '', actividad: '', rutinaria: true, clasificacion: 'fisico', peligro: '', efectos: '',
  ctrl_fuente: '', ctrl_medio: '', ctrl_individuo: '', nd: 6, ne: 3, nc: 25, num_expuestos: 1,
  peor_consecuencia: '', requisito_legal: '', m_eliminacion: '', m_sustitucion: '', m_ingenieria: '', m_administrativa: '', m_epp: '' };

function gtc45(nd, ne, nc) {
  const np = (+nd) * (+ne), nr = np * (+nc);
  const nivel_np = np >= 24 ? 'Muy Alto' : np >= 10 ? 'Alto' : np >= 6 ? 'Medio' : np >= 2 ? 'Bajo' : 'Nulo';
  let nivel_nr, acept;
  if (nr >= 600) { nivel_nr = 'I'; acept = 'No aceptable'; }
  else if (nr >= 150) { nivel_nr = 'II'; acept = 'No aceptable o aceptable con control específico'; }
  else if (nr >= 40) { nivel_nr = 'III'; acept = 'Mejorable'; }
  else { nivel_nr = 'IV'; acept = 'Aceptable'; }
  return { np, nr, nivel_np, nivel_nr, acept };
}

export default function SgsstRiesgos() {
  const [lista, setLista] = useState([]);
  const [modal, setModal] = useState(null);
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => getSgsstRiesgos().then(r => setLista(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const flash = (ok, text) => { setMsg({ ok, text }); setTimeout(() => setMsg(null), 4000); };

  const guardar = async () => {
    const f = modal.form;
    if (!f.peligro?.trim()) return flash(false, 'Describe el peligro');
    setBusy(true);
    try {
      if (modal.id) await editarSgsstRiesgo(modal.id, f); else await crearSgsstRiesgo(f);
      setModal(null); load(); flash(true, '✅ Riesgo guardado');
    } catch (err) { flash(false, '❌ ' + (err.response?.data?.error || 'No se pudo guardar')); }
    finally { setBusy(false); }
  };
  const eliminar = async (r) => {
    if (!window.confirm('¿Eliminar este riesgo de la matriz?')) return;
    try { await borrarSgsstRiesgo(r.id); load(); } catch (e) { flash(false, 'No se pudo eliminar'); }
  };

  return (
    <div style={s.wrap}>
      <SgsstTabs />
      <div style={s.head}>
        <div>
          <h1 style={s.h1}>Matriz de riesgos (IPER)</h1>
          <p style={s.sub}>Identificación de peligros y valoración de riesgos — metodología GTC-45.</p>
        </div>
        <button style={s.btn} onClick={() => setModal({ form: { ...VACIO } })}>+ Nuevo riesgo</button>
      </div>
      {msg && <div style={{ ...s.msg, background: msg.ok ? '#064e3b' : '#450a0a', color: msg.ok ? '#6ee7b7' : '#fca5a5' }}>{msg.text}</div>}

      <div style={s.card}>
        <div style={{ overflowX: 'auto' }}>
          <table style={s.table}>
            <thead><tr>{['Proceso', 'Peligro', 'Clasificación', 'Expuestos', 'NP', 'NR', 'Nivel', 'Aceptabilidad', ''].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
            <tbody>
              {lista.length === 0 && <tr><td colSpan={9} style={s.empty}>Sin riesgos. Empieza a construir tu matriz IPER.</td></tr>}
              {lista.map(r => (
                <tr key={r.id}>
                  <td style={{ ...s.td, color: '#e2e8f0' }}>{r.proceso || '—'}<div style={s.sub2}>{r.actividad}</div></td>
                  <td style={s.td}>{r.peligro}</td>
                  <td style={s.td}>{(CLASIF.find(c => c[0] === r.clasificacion) || [, r.clasificacion])[1]}</td>
                  <td style={{ ...s.td, textAlign: 'center' }}>{r.num_expuestos}</td>
                  <td style={{ ...s.td, textAlign: 'center', fontFamily: 'ui-monospace' }}>{r.np}</td>
                  <td style={{ ...s.td, textAlign: 'center', fontFamily: 'ui-monospace', fontWeight: 700 }}>{r.nr}</td>
                  <td style={{ ...s.td, textAlign: 'center' }}><span style={{ ...s.nivel, background: (NIVEL_COLOR[r.nivel_nr] || '#666') + '22', color: NIVEL_COLOR[r.nivel_nr] || '#999' }}>{r.nivel_nr}</span></td>
                  <td style={{ ...s.td, fontSize: 12, color: '#94a3b8' }}>{r.aceptabilidad}</td>
                  <td style={s.td}>
                    <button style={s.link} onClick={() => setModal({ id: r.id, form: { ...VACIO, ...r } })}>Editar</button>
                    <button style={{ ...s.link, color: '#fca5a5' }} onClick={() => eliminar(r)}>Eliminar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {modal && <RiesgoModal modal={modal} setModal={setModal} guardar={guardar} busy={busy} />}
    </div>
  );
}

function RiesgoModal({ modal, setModal, guardar, busy }) {
  const f = modal.form;
  const set = (k, v) => setModal({ ...modal, form: { ...f, [k]: v } });
  const v = useMemo(() => gtc45(f.nd, f.ne, f.nc), [f.nd, f.ne, f.nc]);
  return (
    <div style={s.overlay} onClick={() => setModal(null)}>
      <div style={s.modal} onClick={e => e.stopPropagation()}>
        <h3 style={s.modalTitle}>{modal.id ? 'Editar riesgo' : 'Nuevo riesgo'}</h3>

        <Sec title="Identificación" />
        <Grid>
          <F l="Proceso"><input style={s.in} value={f.proceso} onChange={e => set('proceso', e.target.value)} /></F>
          <F l="Zona / área"><input style={s.in} value={f.zona_area} onChange={e => set('zona_area', e.target.value)} /></F>
        </Grid>
        <F l="Actividad"><input style={s.in} value={f.actividad} onChange={e => set('actividad', e.target.value)} /></F>
        <Grid>
          <F l="Clasificación del peligro">
            <select style={s.in} value={f.clasificacion} onChange={e => set('clasificacion', e.target.value)}>
              {CLASIF.map(([v2, l]) => <option key={v2} value={v2}>{l}</option>)}
            </select>
          </F>
          <F l="Rutinaria">
            <select style={s.in} value={f.rutinaria ? '1' : '0'} onChange={e => set('rutinaria', e.target.value === '1')}>
              <option value="1">Sí</option><option value="0">No</option>
            </select>
          </F>
        </Grid>
        <F l="Descripción del peligro"><textarea style={s.ta} value={f.peligro} onChange={e => set('peligro', e.target.value)} /></F>
        <F l="Efectos posibles"><textarea style={s.ta} value={f.efectos} onChange={e => set('efectos', e.target.value)} /></F>

        <Sec title="Controles existentes" />
        <Grid3>
          <F l="Fuente"><input style={s.in} value={f.ctrl_fuente} onChange={e => set('ctrl_fuente', e.target.value)} /></F>
          <F l="Medio"><input style={s.in} value={f.ctrl_medio} onChange={e => set('ctrl_medio', e.target.value)} /></F>
          <F l="Individuo"><input style={s.in} value={f.ctrl_individuo} onChange={e => set('ctrl_individuo', e.target.value)} /></F>
        </Grid3>

        <Sec title="Valoración GTC-45" />
        <Grid3>
          <F l="Nivel de deficiencia (ND)"><select style={s.in} value={f.nd} onChange={e => set('nd', +e.target.value)}>{ND.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}</select></F>
          <F l="Nivel de exposición (NE)"><select style={s.in} value={f.ne} onChange={e => set('ne', +e.target.value)}>{NE.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}</select></F>
          <F l="Nivel de consecuencia (NC)"><select style={s.in} value={f.nc} onChange={e => set('nc', +e.target.value)}>{NC.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}</select></F>
        </Grid3>
        <div style={s.calc}>
          <span>NP = <b>{v.np}</b> <small>({v.nivel_np})</small></span>
          <span>NR = <b>{v.nr}</b></span>
          <span style={{ ...s.nivel, background: (NIVEL_COLOR[v.nivel_nr]) + '22', color: NIVEL_COLOR[v.nivel_nr], fontSize: 13 }}>Nivel {v.nivel_nr}</span>
          <span style={{ color: NIVEL_COLOR[v.nivel_nr], fontWeight: 600 }}>{v.acept}</span>
        </div>
        <Grid>
          <F l="Nº expuestos"><input type="number" style={s.in} value={f.num_expuestos} onChange={e => set('num_expuestos', +e.target.value)} /></F>
          <F l="Peor consecuencia"><input style={s.in} value={f.peor_consecuencia} onChange={e => set('peor_consecuencia', e.target.value)} /></F>
        </Grid>
        <F l="Requisito legal aplicable"><input style={s.in} value={f.requisito_legal} onChange={e => set('requisito_legal', e.target.value)} /></F>

        <Sec title="Medidas de intervención (jerarquía de controles)" />
        <F l="Eliminación"><input style={s.in} value={f.m_eliminacion} onChange={e => set('m_eliminacion', e.target.value)} /></F>
        <F l="Sustitución"><input style={s.in} value={f.m_sustitucion} onChange={e => set('m_sustitucion', e.target.value)} /></F>
        <F l="Controles de ingeniería"><input style={s.in} value={f.m_ingenieria} onChange={e => set('m_ingenieria', e.target.value)} /></F>
        <F l="Controles administrativos"><input style={s.in} value={f.m_administrativa} onChange={e => set('m_administrativa', e.target.value)} /></F>
        <F l="EPP"><input style={s.in} value={f.m_epp} onChange={e => set('m_epp', e.target.value)} /></F>

        <div style={s.modalBtns}>
          <button style={s.btnGhost} onClick={() => setModal(null)}>Cancelar</button>
          <button style={s.btn} disabled={busy} onClick={guardar}>{busy ? 'Guardando…' : 'Guardar'}</button>
        </div>
      </div>
    </div>
  );
}

const Sec = ({ title }) => <div style={s.sec}>{title}</div>;
const F = ({ l, children }) => <div style={{ marginBottom: 10 }}><label style={s.lbl}>{l}</label>{children}</div>;
const Grid = ({ children }) => <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>{children}</div>;
const Grid3 = ({ children }) => <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: 12 }}>{children}</div>;

const s = {
  wrap: { padding: 4 },
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16, flexWrap: 'wrap', gap: 12 },
  h1: { color: '#f1f5f9', fontSize: 24, fontWeight: 700, margin: '0 0 4px' },
  sub: { color: '#64748b', fontSize: 14, margin: 0 },
  sub2: { color: '#64748b', fontSize: 11, marginTop: 2 },
  btn: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnGhost: { background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 8, padding: '10px 18px', fontSize: 14, cursor: 'pointer' },
  msg: { padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 14 },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13, minWidth: 820 },
  th: { textAlign: 'left', padding: '10px 12px', color: '#64748b', fontSize: 11, textTransform: 'uppercase', letterSpacing: .5, borderBottom: '1px solid #334155', background: '#0f172a', whiteSpace: 'nowrap' },
  td: { padding: '10px 12px', color: '#94a3b8', borderBottom: '1px solid #1e293b', verticalAlign: 'top' },
  empty: { padding: 30, textAlign: 'center', color: '#64748b' },
  nivel: { padding: '2px 9px', borderRadius: 20, fontSize: 12, fontWeight: 700 },
  link: { background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: 13, marginRight: 10, padding: 0 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  modal: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 18, width: 640, maxWidth: '96vw', maxHeight: '92vh', overflowY: 'auto' },
  modalTitle: { color: '#f1f5f9', fontSize: 18, fontWeight: 700, margin: '0 0 8px' },
  modalBtns: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 18 },
  sec: { color: '#f59e0b', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: .6, margin: '18px 0 10px', paddingBottom: 5, borderBottom: '1px solid #334155' },
  lbl: { display: 'block', color: '#94a3b8', fontSize: 12, marginBottom: 4 },
  in: { width: '100%', boxSizing: 'border-box', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 11px', color: '#f1f5f9', fontSize: 13.5 },
  ta: { width: '100%', boxSizing: 'border-box', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 11px', color: '#f1f5f9', fontSize: 13.5, minHeight: 54, resize: 'vertical', fontFamily: 'inherit' },
  calc: { display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '10px 14px', margin: '4px 0 12px', fontSize: 14, color: '#cbd5e1' },
};
